import React, { useState } from 'react';
import Sidebar from '../../../shared/components/Sidebar';
import PageLayout from '../../../shared/components/PageLayout';
import {
  Box, Paper, Typography, List, ListItem, ListItemButton, ListItemIcon,
  ListItemText, Divider, Switch, Alert
} from '@mui/material';
import {
  Tag as TagIcon,
  Notifications,
  Security,
  Info,
  ArrowForward
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Settings = () => {
  const navigate = useNavigate();
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const [autoModeration, setAutoModeration] = useState(false);

  const settingsSections = [
    {
      title: 'Content Moderation',
      items: [
        {
          icon: <TagIcon />,
          label: 'Manage Hashtags',
          description: 'Block or report offensive hashtags',
          action: () => navigate('/manage-hashtags'),
          showArrow: true
        }
      ]
    },
    {
      title: 'Notifications',
      items: [
        {
          icon: <Notifications />,
          label: 'Push Notifications',
          description: 'Enable or disable push notifications',
          toggle: true,
          value: notificationsEnabled,
          onChange: setNotificationsEnabled
        }
      ]
    },
    {
      title: 'Security',
      items: [
        {
          icon: <Security />,
          label: 'Auto Moderation',
          description: 'Automatically flag potentially offensive content',
          toggle: true,
          value: autoModeration,
          onChange: setAutoModeration
        }
      ]
    },
    {
      title: 'About',
      items: [
        {
          icon: <Info />,
          label: 'App Version',
          description: 'v1.0.0',
          disabled: true
        }
      ]
    }
  ];

  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboard--content">
        <PageLayout title="Settings">
          <Alert severity="info" sx={{ mb: 3 }}>
            Configure application settings and content moderation preferences
          </Alert>

          {settingsSections.map((section, idx) => (
            <Paper key={idx} sx={{ mb: 3, borderRadius: 2, overflow: 'hidden', bgcolor: 'var(--card-bg)' }}>
              <Box sx={{ px: 3, py: 2, bgcolor: 'var(--bg-secondary)', borderBottom: '1px solid var(--border-color)' }}>
                <Typography variant="h6" fontWeight={600} fontSize="1rem" color="var(--text-primary)">
                  {section.title}
                </Typography>
              </Box>
              <List disablePadding>
                {section.items.map((item, itemIdx) => (
                  <React.Fragment key={itemIdx}>
                    {itemIdx > 0 && <Divider />}
                    <ListItem
                      disablePadding
                      secondaryAction={
                        item.toggle ? (
                          <Switch
                            checked={item.value}
                            onChange={(e) => item.onChange(e.target.checked)}
                            color="primary"
                          />
                        ) : item.showArrow ? (
                          <ArrowForward sx={{ color: '#999' }} />
                        ) : null
                      }
                    >
                      <ListItemButton
                        onClick={item.action}
                        disabled={item.disabled}
                        sx={{ py: 2 }}
                      >
                        <ListItemIcon sx={{ minWidth: 48 }}>
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography fontWeight={500}>{item.label}</Typography>
                          }
                          secondary={item.description}
                        />
                      </ListItemButton>
                    </ListItem>
                  </React.Fragment>
                ))}
              </List>
            </Paper>
          ))}

          <Paper sx={{ p: 3, borderRadius: 2, bgcolor: 'var(--bg-secondary)', border: '1px solid var(--border-color)' }}>
            <Typography variant="h6" fontWeight={600} gutterBottom color="var(--text-primary)">
              Content Moderation Guidelines
            </Typography>
            <Typography variant="body2" color="var(--text-secondary)" paragraph>
              • Blocked hashtags are removed from public visibility
            </Typography>
            <Typography variant="body2" color="var(--text-secondary)" paragraph>
              • Users cannot create new posts with blocked hashtags
            </Typography>
            <Typography variant="body2" color="var(--text-secondary)" paragraph>
              • Reported hashtags are flagged for admin review
            </Typography>
            <Typography variant="body2" color="var(--text-secondary)">
              • Search results show "not available" message for blocked hashtags
            </Typography>
          </Paper>
        </PageLayout>
      </div>
    </div>
  );
};

export default Settings;
